import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function ViewStorage (){
  const {user} = useUser()
  let view = contentLayout[modules.StorageItemList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.StorageItemList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.StorageItemList}></Index>
 )
}

export default ViewStorage